import { useCallback } from "react";
import { RejoinModalViewModel } from "../../session/rejoin/types";
import {
  REJOIN_ERROR_TOAST_TAGS,
  RejoinError,
  useBaseRejoinModalViewModel,
} from "../../session/rejoin/useBaseRejoinModalViewModel";
import { toast } from "../../toasts";
import { useProviderDisconnectRoomCallback } from "../useProviderDisconnectRoomCallback";

function errorToToastMessage(error: RejoinError) {
  const errorKind = "kind" in error ? error.kind : "unexpected";
  switch (errorKind) {
    case "empty-room":
      return "Your patient may have left the session. Please re-admit the patient.";
    default:
      return "An unexpected error occurred. Please re-admit the patient.";
  }
}

function showErrorToast(error: RejoinError) {
  toast.error(errorToToastMessage(error), {
    purpose: "system",
    tags: REJOIN_ERROR_TOAST_TAGS,
  });
}

export function useProviderRejoinModalViewModel(): RejoinModalViewModel {
  const { isLoading, isOpen, rejoin, closeModal } =
    useBaseRejoinModalViewModel();
  const disconnect = useProviderDisconnectRoomCallback();

  const handleRejoin = useCallback(() => {
    rejoin({
      onTerminalFailure: async (error) => {
        return disconnect().finally(() => {
          showErrorToast(error);
          closeModal();
        });
      },
    });
  }, [closeModal, disconnect, rejoin]);

  return {
    isOpen,
    isLoading,
    onJoin: handleRejoin,
  };
}
